import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  MainContainer: {
    height: "auto",
    background: "linear-gradient(179deg, #1F3052 27.67%, #49A995 149.13%)",
    padding: "1px 1px",
    "@media (max-width: 625px)": {
      fontSize: 55,
    },
  },
  PlumbingBg: {
    backgroundImage: `url("/ActivityBG.png")`,
    backgroundPosition: "center",
    height: 434,
    backgroundRepeat: "no-repeat",
    marginTop: 106,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "@media (max-width: 1000px)": {
      backgroundSize: "100% auto",
      marginTop: 0,
    },

    "@media (max-width: 915px)": {
      backgroundImage: `url("/ActivityBG.pn")`,
      backgroundColor: "#49A995",
      height: "auto",
    },
  },

  PlumbingTextContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px",

    "@media (max-width: 780px)": {
      flexDirection: "column",
    },
  },
  PlumbingMainHeading: {
    "&.MuiTypography-root": {
      color: "#1F3052",
      fontSize: 45,
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 700,
      lineHeight: "115%",
      letterSpacing: "-1.6px",
      textAlign: "center",

      "@media (max-width: 780px)": {
        marginTop: "15px",
        marginBottom: "15px",
      },
    },
  },
  span: {
    display: "block",
  },
  VosSpan: {
    display: "block",
  },
  TransformonsSpan: {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",
  },
  EnSpan: {
    fontSize: 40,
    color: "#FFF",
    fontWeight: 500,
  },

  LastLine: {
    display: "block",
  },
  performanceSpan: {
    fontSize: 40,
    color: "#FFF",
    fontWeight: 500,
  },

  colorWhite: {
    color: "#FFF",
    fontWeight: 500,
  },
  Divider: {
    width: 1,
    height: 215,
    backgroundColor: "black",
    marginLeft: 24,
    marginRight: 32,
    "@media (max-width: 780px)": {
      height: 1,
      width: "97%",
    },
  },
  AboutPlumbing: {
    "&.MuiTypography-root": {
      color: "#1F3052",
      fontSize: 14,
      fontFamily: "'Inter', sans-serif",
      fontWeight: 400,
      lineHeight: "normal",
      letterSpacing: "-0.30px",
      width: 375,

      "@media (max-width: 780px)": {
        marginTop: "15px",
        marginBottom: "30px",
        textAlign: "center",
      },
    },
  },

  AboutPlumbingList: {
    padding: 0,
    color: "#1F3052",
    fontSize: 14,
    fontFamily: "'Inter', sans-serif",
    fontWeight: 400,
    lineHeight: "normal",
    letterSpacing: " -0.56px",
    width: 371,
    "& li": {
      margin: "5px 0px",
    },
  },
  AboutPlumbingSpan: {
    display: "block",
    marginTop: 20,
  },
  AboutWrapper: {
    height: 210,
  },
  ReadMoreButton: {
    "&.MuiButtonBase-root": {
      padding: 0,
      textTransform: "capitalize",
      color: "#1F3052",
      fontFamily: "'Inter', sans-serif",
      fontWeight: 400,
      marginTop: 15,
    },
  },
  YourActivityMainWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginTop: 77.71,
    marginBottom: "6rem",
    "@media (max-width: 900px)": {
      marginBottom: "10rem",
    },
  },
  YourActivityWrapper: {
    display: "flex",
    // alignItems: "center",
    justifyContent: "space-evenly",
    width: "100%",
    overflowX: "auto", // visible scrollbar
    alignItems: "stretch", // key for equal height
    overflow: "'hidden",

    "@media (max-width: 1080px)": {
      gap: "32px",
      padding: "16px",
      width: "95%",
      margin: "auto",
      overflowX: "auto",
      overflowY: "hidden",
      display: "flex",
      flexWrap: "wrap",
      // Always show scrollbar - Firefox
      scrollbarWidth: "auto",
      scrollbarColor: "rgba(0, 0, 0, 0.5) transparent",
      // Always show scrollbar - Chrome/Safari
      "&::-webkit-scrollbar": {
        height: "8px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
      },
    },
  },

  YourActivityContainer: {
    display: "flex",
    flexDirection: "column",
    // alignItems: "center",
    margin: "0rem 2rem",
    height: "100%",
    "@media (max-width: 570px)": {
      fontSize: 55,
      margin: "0rem 0rem",
    },
  },
  YourActivityContainerComplexe: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "0.5rem 2rem",
  },
  YourActivitiesTitle: {
    "&.MuiTypography-root": {
      color: "#FFF",
      fontSize: 64,
      fontFamily: "'Poppins', sans-serif",
      fontStyle: "italic",
      fontWeight: 400,
      lineHeight: "93%",
      letterSpacing: " -1.28px",
      marginBottom: "6rem",
      "@media (max-width: 570px)": {
        fontSize: 55,
        marginBottom: "2rem",
      },
    },
  },
  YourActivitiesSpan: {
    color: "#49A995",
    fontSize: "84px",
    fontFamily: "'Poppins', sans-serif",
    fontStyle: "italic",
    fontWeight: 600,
    lineHeight: "93%",
    letterSpacing: " -1.68px",
    "@media (max-width: 570px)": {
      fontSize: "60px",
    },
    "@media (max-width: 405px)": {
      fontSize: "50px",
    },
  },
  YourActivityHeading: {
    "&.MuiTypography-root": {
      color: "#FFF",
      fontSize: 30,
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 700,
      // textAlign: "center",
      marginBottom: "1.5rem",
      "&:hover": {
        color: "#49A995", // or any hover color you want
        cursor: "pointer",
      },
    },
  },
  YourActivityPara: {
    "&.MuiTypography-root": {
      color: "#49A995",
      fontSize: 18,
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 300,
      lineHeight: "normal",
      letterSpacing: "-0.60px",
      textAlign: "left",
      width: 390,
    },
  },

  CompanyIntroText: {
    "&.MuiTypography-root": {
      color: "#FFF",
      fontSize: 22,
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 250,
      lineHeight: "normal",
      textAlign: "left",
      // width: 340,
    },
  },
  SonaBimTEXT: {
    fontWeight: "bold",
    color: "#FFF",
  },
  GexiaText: {
    fontWeight: "bold",
    color: "#FFF",
  },
  unissenText: {
    color: "#49A995",
    fontWeight: 500,
  },

  CompanyIntroList: {
    color: "#FFF",
    paddingLeft: 16,
    marginTop: 20,
    fontSize: 22,
  },
  NotreText: {
    color: "#49A995",
    fontStyle: "italic",
    fontSize: 25,
    fontWeight: 700,
    display: "block",
  },
  SonaBimIndustrieText: {
    fontWeight: "bold",
  },
  SolutionsText: {
    color: "#49A995",
    fontWeight: 600,
  },
  YourActivityParatrannsport: {
    "&.MuiTypography-root": {
      color: "#FFF",
      fontSize: 22,
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 250,
      lineHeight: "normal",
      letterSpacing: "-0.60px",
      textAlign: "left",
      width: 340,
    },
  },

  IndustryFocusText: {
    "&.MuiTypography-root": {
      color: "#FFF",
      fontSize: 22,
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 250,
      lineHeight: "normal",
      letterSpacing: "-0.60px",
      textAlign: "left",
      // marginTop: 15,
      // margin: "10px 10px",
      width: 340,
    },
  },
  IndustryListSpan: {
    color: "#49A995",
    fontSize: 18,
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    lineHeight: "normal",
    letterSpacing: "-0.60px",
    textAlign: "center",
    marginTop: 15,
    // margin: "10px 10px",
    width: 340,
  },
  YourActivitySubPara: {
    "&.MuiTypography-root": {
      color: "#FFF",
      fontSize: 18,
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 300,
      lineHeight: "normal",
      letterSpacing: "-0.56px",
      textAlign: "center",
      width: 300,
    },
  },

  BenefitText: {
    "&.MuiTypography-root": {
      color: "#FFF",
      fontSize: 14,
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 400,
      lineHeight: "normal",
      letterSpacing: "-0.56px",
      textAlign: "center",
      marginTop: 10,
    },
  },
  savoirBtn: {
    "&.MuiButtonBase-root": {
      color: "white",
      fontFamily: "'Poppins', sans-serif",
      fontSize: 14,
      textTransform: "capitalize",
      marginTop: "1.6rem",
      position: "relative",
      width: 250,
      zIndex: 1,
      backgroundColor: "#49A995",
      height: 40,
      "&:hover": {
        color: "white",
        backgroundColor: "#025b62ff",
      },
    },
  },
  TravelBimWhitelogo: {
    marginTop: "1rem",
    cursor: "pointer",
    backgroundColor: "#ffffff1a", // light white overlay
    padding: "12px 20px",
    borderRadius: "8px",
    transition: "background-color 0.3s, box-shadow 0.3s",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    width: 220,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#ffffff33",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    },
  },
  TransportScope: {
    color: "#FFF",
    fontWeight: 500,
  },
  ProjectFocusText: {
    fontWeight: 500,
    color: "#FFF",
  },
  CompanyCollaboration: {
    fontWeight: 500,
  },
  DashedObjectiveContainer: {
    border: "2px dashed rgba(255, 255, 255, 0.4)",
    padding: "2rem",
    borderRadius: "12px",
    marginTop: "1.5rem",
    width: "100%",
    maxWidth: 380,
    height: 500,
    "@media (max-width: 550px)": {
      maxWidth: 300,
      height: "auto",
    },
  },
  MarginTopExtra: {
    marginTop: "3rem",
  },
  IndustryListSpacing: {
    // marginTop: "7.3rem",
  },
  SectorIntroText: {
    "&.MuiTypography-root": {
      color: "#FFF",
      fontSize: 22,
      fontFamily: "'Poppins', sans-serif",
      fontStyle: "italic",
      fontWeight: 300,
      // marginBottom: "0.5rem",
    },
  },
  SectorListBlock: {
    marginTop: "2rem",
  },
  ButtonMarginTopExtra: {
    "&.MuiButtonBase-root": {
      marginTop: "3.6rem",
    },
  },
  TravelBimCard: {
    marginTop: "7rem",
  },
}));
